module.exports = {
  //交互反馈
  request: {
    201: "パラメータエラー",
    202: "アカウントを空にすることはできません",
    203: "パスワードが空です",
    204: "アカウントのエラー",
    205: "パスワードエラー",
    206: "情報が間違っています。管理者に連絡してください。",
    207: "貨幣の種類が存在しない",
    208: "購入数量が範囲外にある",
    300: "要求に失敗しました",
    209: "パスワードが一致しません",
    236: "アカウントは既に存在します",
    211: "元のパスワードが間違っています",
    212: "新しいパスワードは空にできません。",
    213: "名前は空にしにくいです",
    214: "名字は空ではいけません",
    215: "証明書の種類を選んでください。",
    216: "証明書の番号は空いてはいけません。",
    217: "正面の証明書の写真は空です。",
    218: "裏の証明書の写真は空です。",
    219: "国籍を選択してください",
    220: "証明書を持って写真を撮ってアップロードしてください",
    221: "マネーロンダリング反対の署名写真をアップロードしてください",
    222: "残高不足です",
    223: "注文エラー、管理者に連絡してください",
    230: "選択した通貨は同じではありません",
    234: "正しいメールボックスを使用してください",
    235: "認証コードが正しくありません",
    237: "現在のアカウントは登録されていませんので、登録してください",
    231: "選択した通貨は空にできません"
  },

  //国家
  country: {
    Usa: "アメリカ",
    China: "中国",
    korea: "韓国",
    Japan: "日本",
    HongKong: "香港",
    Taiwan: "中国台湾",
    Russia: "ロシア",
    France: "フランス",
    britain: "イギリス",
    Germany: "ドイツ",
    Brazil: "ブラジル",
    Italy: "イタリア",
    Canada: "カナダ",
    Spain: "スペイン",
    Malaysia: "マレーシア",
    Singapore: "シンガポール",
    Indonesia: "インドネシア",
    Philippines: "フィリピン",
    Vietnam: "ベトナム",
    India: "インド",
    Bhutan: "ブータン",
    Finland: "フィンランド",
    Sweden: "スウェーデン",
    Norway: "ノルウェー",
    Iceland: "アイスランド",
    Denmark: "デンマーク",
    zimbabwe: "ジンバブエ",
    Netherlands: "オランダ",
    Thailand: "タイ",
  },

  //证件
  certificates: {
    passport: "パスポート",
    ID: "身分証明書",
    driverLicense: "運転免許証"
  },

  //通用
  currency: {
    loading: "読み込み中",
    determine: "を選択します",
    cancel: "キャンセル",
    tips: "ヒント",
    psdRule: "密码必须是字母+数字组合",
    psdLength: "密码长度不得少于6位",
    loginPsdLength: "パスワードの長さは8桁を下回ってはいけません。",
    actionSuccess: "操作成功",
    success: "成功",
    fail: "失敗",
    passed: "レビュー中",
    return: "返回"
  },

  // 登陆页
  login: {
    welComeToLogin: 'ログインを歓迎します',
    username: "アカウント",
    password: "パスワード",
    submit: "送信",
    noAccount: "アカウントがありません",
    register: "登録する",
    forgetPassword: "パスワードを忘れます",
    loginSuccess: "ログイン成功",
    logoutSuccess: "ログアウト",
    enterAccount: "アカウントを入力してください",
    enterPsw: "パスワードを入力してください",
    rememberPassword: "パスワードを記憶する"
  },

  //注册页
  register: {
    registeredAccount: "アカウントを登録する",
    mailboxRegistration: "メールアドレス登録",
    mailbox: "メールボックス",
    setPassword: "パスワードの設定",
    confirmPassword: "パスワードを確認する",
    readAgree: "私はすでに読んで同意しました。",
    userAgreement: "ユーザプロトコル",
    and: "を選択します",
    privacyClause: "ステルス条項",
    existingAccount: "既存のアカウント",
    signIn: 'ログイン',
    registerSuccess: "登録成功",
    pleaseRead: "まずユーザー協議とプライバシー条項を読んでください",
    inviteCode: "招待コード",
    verificationCode: "認証コード",
  },

  //忘记密码
  forgetPassword: {
    code: "検証コード",
    forgetPassword: "パスワードを忘れる",
    sendCode: "検証コードを送信する"
  },

  //顶部导航栏
  nav: {
    home: "最初のページ",
    quotation: "相場",
    transaction: "取引",
    notice: "公告する",
    securityCenter: "安全センター",
    assets: "私の資産",
    recharge: "チャージ",
    withDrawal: "現金で出す",
    fundTransfer: "資金の振り替え",
    orderCenter: "注文センター",
    exchange: "両替する",
    logOut: "登出する",
    downloadApp: "コードをスキャンしてアプリケーションをダウンロードします",
    moreClient: "もっと多くのユーザー端末",
    chinese: "中国語",
    traditionalChinese: "繁体字",
    english: "英語",
    korean: "韓国語",
    japanese: "日本語",
    continueToExit: "終了するかどうか"
  },

  //首页
  home: {
    name: "名前",
    price: '価格',
    amount: "今日は下げ幅が上がった",
    title: "いつでもどこでも取引する",
    desc: "多端末は完璧に対応しており、いつでも様々なシーンの取引ニーズを満たす",
    text1: "リアルタイムの相場を随時調べる",
    text2: "轻松买卖BTC,ETH,XRP,OKB和其他数字资产",
    text3: "お気に入りの暗号化された通貨の価格変化に関する警告を取得します",
    text4: "ビットコインの現物、先物、オプション価格を確認します",
    text5: "各取引所の暗号化された貨幣価格を比較する",
    title1: "世界をリード",
    title2: "デジタル資産サービスプラットフォーム",
    desc2: "安全 ・ 安定 ・ 信頼性",
    createAccount: "アカウントの作成",
    text6: "デジタル通貨の旅を開く"
  },

  //行情
  quotes: {
    title: "今日の相場"
  },

  //安全中心
  securityCenter: {
    identityAuthentication: "認証",
    desc: "個人認証を完成することは、口座の安全を保護し、現金引き出し額及び取引権限を高めることに役立つ",
    go: "行きます",
    loginPassword: "ログインパスワード",
    desc1: "アカウントのセキュリティを保護するために使用します",
    edit: "変更",
    fundPassword: '資金コード',
    desc2: "資金の安全保護に用いる",
    setUp: "設定",
    changePassword: "パスワードを変更",
    changePasswordAlert: "修改登录密码后24小时内禁止提币和OTC划转",
    originalPassword: "元のパスワード",
    newPassword: "新しいパスワード",
    confirmPassword: "新しいパスワードを確認します",
    setFundPassword: "資産のパスワードを設定",
    resetFundPassword: "資産のパスワードをリセット",
    confirmFundPassword: "資産のパスワードをリセット",
    setSuccessfully: "設定成功"
  },

  //身份认证
  personalAuthentication: {
    identityAuthentication: "認証",
    personalIdentityAuthentication: "個人認証",
    know: "委細承知しました",
    primaryCertification: "ジュニア認証",
    desc: "增加提币额度，24小时限额200BTC",
    advancedCertification: "認証",
    submitApproval: "決裁に付す",
    agreementDownload: 'アンチマネーロンダリングプロトコルのダウンロード',
    handCertificates: "手に持っている証明書の写真をアップロードしてください",
    handCertificates2: "アンチマネーロンダリング契約の写真をアップロードしてください",
    national: "国籍",
    surname: "名前",
    realname: "名前",
    papersType: "証明書の種類",
    papers: "証明書番号",
    papersPositive: "証明書の正面の写真をアップロードしてください",
    papersReverse: "証明書の裏の写真をアップロードしてください",
    pleaseEnter: "入力してください",
    title: "为什么我必须进行身份认证",
    content: "実名認証は現在の金融法規または関連政策を遵守するためです。実名認証はあなたの口座の安全を守り、一部の詐欺手段を避けるために役立ちます。あなたの情報を厳重に秘密にします",
    title2: "暂时不支持哪些国家",
    content2: "実名認証は現在の金融法規または関連政策を遵守するためです。実名認証はあなたの口座の安全を守り、一部の詐欺手段を避けるために役立ちます。あなたの情報を厳重に秘密にします",
    verificationCertification: "先に上級資格認定を取得してください",
    authentication: "即時認証",
    PrimaryAuditPassed: "初級審査合格",
    level0: "登録済み",
    level1: "初級審査中",
    level2: "初級審査が通過しなかった",
    level3: "初級審査合格",
    level4: "詳細レビュー中",
    level5: "詳細レビューが失敗しました",
    level6: "詳細レビューの承認",
  },

  //交易
  transaction: {
    pleaseSelect: "選択してください",
    price: "価格",
    requiredMargin: "必要な保証金",
    closingFee: "平倉手数料",
    stopSurplus: "しゅうりょう",
    default: "デフォルト",
    stopLoss: "ぼうそん",
    purchase: "買い入れる",
    currentPosition: "現在倉庫を持っている.",
    historicalContract: "履歴契約",
    order: "オーダー番号",
    creationTime: "作成時間",
    transactionType: "取引タイプ",
    buyUp: "買い上げる",
    buyFall: "買い下がる",
    num: "数量",
    bond: "保証金",
    serviceCharge: "手数料",
    ClosingProfitLoss: "平倉損益",
    netProfitLoss: "純損益",
    orderStatus: "注文の状況",
    operation: "操作する",
    compulsoryLiquidation: "強制清算",
    forceClosing: "ポジションを清算してもよろしいですか?",
    pleaseLogin: "まだログインしていません。最初にログインしてください。",
    buyCurrentPrice: "現在の通貨価格は0です",
    charged: "閉店時間",
    buildingTime: "開始時間",
    buildingPrice: "始値",
    currencyPriceNew: "終値",
    heightPrice: "24時間高",
    lowPrice: "24時間低",
    latestTransaction: "最新の成約",
    FloatingPL: "浮動損益",
    storageFee: "倉庫保管費",
    status1: "オートマチックバラスト",
    status2: "じどうしょうそんへいき",
    status3: "手動止め平倉",
    status4: "手動止損平倉",
    status5: "実行中",
  },

  assets: {
    accountOverview: "アカウント一覧",
    currencyAccount: "貨幣口座",
    contractAccount: "契約口座",
    transfer: "ぐるぐる回る",
    withdrawMoney: "貨幣を引き出す",
    chargeMoney: "貨幣を充てる",
    Cryptocurrency: "暗号化された通貨",
    currency: "通貨",
    available: "使用可能",
    valuation: "評価",
    operation: "操作",
    chargingCurrency: "通貨通貨の選択",
    currencyType: "通貨",
    alert1: "最小チャージ金額",
    alert2: "最小金額未満の預金はアカウントに転記されず、返金できません",
    ChargingInfo: "通貨情報を確認する",
    ChargingNetwork: "預金ネットワーク",
    rule2: "上記のアドレスにリチャージした後、ネットワークノード全体の確認が必要です。12回のネットワーク確認後、クレジットされます。12回のネットワーク確認後、コインを引き出すことができます。",
    rule3_btc: "最低入金額：0.01BTC、最低入金額未満の入金はアカウントに入金されず、返金できません。",
    rule3_usdt: "最小リチャージ額：300USDT、最小リチャージ未満のリチャージはアカウントに入金されず、返金できません。",
    rule3_eth: "最低入金額：0.15ETH、最低入金額未満の入金はアカウントに入金されず、返金できません。",
    rule4: "リチャージアドレスは頻繁に変更されることはなく、リチャージできます。変更があった場合は、ウェブサイトのお知らせまたはメールで通知できるよう最善を尽くします。",
    rule5: "情報の改ざんや漏洩を防ぐため、パソコンやブラウザのセキュリティを必ず確認してください。",
    ChargingRecord: "預金記録",
    time: "時間",
    netWorkAddress: "ウェブサイトアドレス",
    selectWithdrawalCurrency: "引き出し通貨を選択してください",
    ol1: "資金の安全を確保するため、アカウントのセキュリティポリシーが変更されたり、パスワードが変更されたりした場合は、手動で引き出しを確認します。しばらくお待ちください。スタッフからメールでご連絡があります。",
    ol2: "情報の改ざんや漏洩を防ぐため、パソコンやブラウザのセキュリティを必ず確認してください。",
    withdrawalInfo: "コイン情報の記入",
    withdrawAddress: "コイン・アドレス",
    withdrawalNetwork: "コインネットワーク",
    withdrawalNum: "コイン引出数量",
    minWithdrawalNum: "最小通貨数",
    actualArrival: "実際入金",
    notLessThan: "より小さい値は不可",
    viewAll: "すべての通貨の表示",
    withdrawalRecord: "通貨引出記録",
    transferCurrency: "換算通貨を選択してください",
    transferNum: "回転数",
    from: "から",
    to: "に着く",
    transferRecord: "スクラッチレコード",
    exceedBalance: "使用可能数量以下",
    use: "使用",
    convertInto: "に両替",
    exchangeRate: "為替レート",
    exChangeAlert: "工賃率：2%|無断欠勤費自己負担",
    exchangeInstructions: "エクスチェンジノート",
    desc1: "資金交換は市況や市況の影響を受け、価格は随時変動しますので、ご注文確定後の最終金額をご確認ください。",
    desc2: "リスク管理システムの要件に従い、資金の交換によって第三者のリスク管理がトリガーされた場合、交換ユーザーは監査人と協力して関連するレビューを完了する必要があります。レビューを完了できない場合、注文は返金されます。少なくとも1か月（30日）であなた",
    desc3: "資金の交換が個人的な行為であることを確認し、ネズミ講、違法な資金調達、詐欺などの違法な活動にデジタル通貨を使用して参加しないことを確認してください。高い関心を約束するすべての違法なプロジェクトに注意してください報告し、不必要な損失を避けるためにだまされることに注意してください",
    exchangeRecord: "交換記録",
    useCurrency: "通貨を使用する",
    exchangeCurrency: "通貨両替",
    AbsenteeismFee: "欠席主義",
    exchangeQuantity: "交換の数",
    paymentPassword: "支払いパスワードを入力してください",
    currencyNoSame: "通貨を同じにすることはできません"
  },

  // 二期
  iteration: {
    contractMarket: "契約市場",
    quotationDesc: "デジタル通貨相場の概要",
    accountOverview: "アカウントの概要",
    accountOverviewDesc: "口座番号資金状況の概要",
    all: "すべて",
    userCenter: "パーソナルセンター",
    viewInfo: "プロファイル情報の表示",
    setPsdDesc: "強度の高いパスワードを設定することで、アカウントのセキュリティが向上",
    homeTitle: "ナンバーワンのアルトコイン取引所",
    homeDesc: "他の取引所では取り扱っていない、有望なコインを見つけましょう。",
    homeTitle2: "世界最大のソーシャルトレーディングプラットフォーム",
    homeDesc2: "全世界の暗号通貨投資家とのやり取りが可能で、信頼性の高い暗号通貨関連ニュースを随時確認できます。",
    homeTitle3: "個人のための取引所",
    homeDesc3: "プラットフォームは、あらゆる種類の投資家向けに設計されています。24時間年中無休で、世界トップクラスのサービスを任意のチャネルや言語でご利用いただけます。",
    homeTitle4: "いつでもどこでも取引可能",
    homeDesc4: "アプリでもWEBでも、取引を迅速に開始することができます",
    homeTitle5: "ビットコインとは何ですか？",
    homeDesc5: "ビットコインは、中央銀行や単一の管理者がいない、非中央集権的なデジタル通貨です。仲介者を介さずに、ユーザー同士がピアツーピアネットワークでビットコインを取引できます。",
    homeTitle6: "取引は1ドルから可能ですか？",
    homeDesc6: "では、さまざまな取引や金融商品を1ドルから利用できるため、実践的な経験を積むことができます。",
    homeTitle7: "BitFuyは安全ですか？",
    homeDesc7: "BitFuyは、世界トップクラスのセキュリティテクノロジーとメンテナンスチームを有しています。セキュリティシステムを常時アップグレードすることで、ユーザーの資産やアカウントの安全性を確保します。",
    homeTitle8: "フィアット通貨と暗号通貨の交換には、上限が設定されていますか？",
    homeDesc8: "BitFuyでは、フィアット通貨と暗号通貨の交換に一切制限を設けていません。",
    homeTitle9: "今すぐ暗号通貨取引を始めましょう！",
    homeDesc9: "BitFuyのアプリやウェブサイトでの取引は非常に簡単です。",
    digitalCurrency: "デジタル通貨",
    qualityInformation: "高品質コンサルティング",
    globalInvestor: "グローバル投資家",
    internationalCommunity: "国際コミュニティ",
    countriesCovered: "カバー国",
    transactionText: "コインの購入には、クレジットカード、銀行振込、Apple Payなどをご利用いただけます。",
    cumulative: "累計＃ルイケイ＃",
    realTimeTransaction: 'リアルタイム成約',
    balance: "残高",
    totalMargin: "総保証金",
    transferQuantityTips: "スクライブ数量は0より大きい必要があります",
    notCertified: "認証されていません",
    certified: "資格認定済み",
    underCertification: "資格認定中",
    digitalCurrencyTransactions: "デジタル通貨取引",
    setCapitalPsw: "資金取引パスワードの設定",
    authenticationTips: "初級認証を行ってください",
    than: "数値は0より大きくなければなりません"
  }
}